const BoardMember = {
  AddMissingInformation: "BoardMember.AddMissingInformation",
  AddInformation: "BoardMember.AddInformation",
  WeNeedCorrectContactInformation: "BoardMember.WeNeedCorrectContactInformation",
  WhyIsThisNeeded: "BoardMember.WhyIsThisNeeded",
  WhyIsThisNeededDescription: "BoardMember.WhyIsThisNeededDescription",
  }
export default BoardMember;